import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'lg:mt-12',
    row: 'flex flex-wrap max-lg:flex-col-reverse',
    content:
      'flex max-w-[538px] flex-col gap-4 text-center max-lg:my-10 lg:gap-6',
    column: 'flex-center flex w-full flex-col gap-6 lg:w-1/2',
    title:
      'text-lg leading-[1.3] font-light tracking-[0.08em] uppercase lg:text-2xl',
    text: 'px-5 text-sm leading-[1.3] font-extralight tracking-[0.07em] lg:text-lg',
    bold: 'font-semibold lg:tracking-[2px]',
    semibold: 'font-medium',
    video: 'block h-full w-full object-cover max-lg:mb-5 max-lg:max-h-[375px]'
  }
});
